webpackJsonp([46],{

/***/ "+yHj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MANAGER_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NEW_MANAGER_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MANAGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BATCH_CREATE_MANAGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TOGGLE_FREEZE_MANAGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_MANAGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SCHOOL_NAME; });
/* unused harmony export INFO */
var MANAGER_LIST = 'school/school-detail/manager/MANAGER_LIST';
var NEW_MANAGER_LIST = 'school/school-detail/manager/NEW_MANAGER_LIST';
var MANAGER = 'school/school-detail/manager/MANAGER';
var BATCH_CREATE_MANAGER = 'school/school-detail/manager/BATCH_CREATE_MANAGER';
var TOGGLE_FREEZE_MANAGER = 'school/school-detail/manager/TOGGLE_FREEZE_MANAGER';
var DELETE_MANAGER = 'school/school-detail/manager/DELETE_MANAGER';
var SCHOOL_NAME = 'school/school-detail/SCHOOL_NAME';
var INFO = 'school/school-detail/INFO';

/***/ }),

/***/ "17Mt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_tab_item_vue__ = __webpack_require__("uZYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_9f75dcf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_tab_item_vue__ = __webpack_require__("3UMI");
function injectStyle (ssrContext) {
  __webpack_require__("FzZB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_tab_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_9f75dcf2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_tab_item_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2bfi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TEACHER_LIST; });
/* unused harmony export BATCH_CREATE_TEACHER */
var TEACHER_LIST = 'learning-center/create-teacher/TEACHER_LIST';
var BATCH_CREATE_TEACHER = 'learning-center/create-teacher/BATCH_CREATE_TEACHER';

/***/ }),

/***/ "2wlW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3JXj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ly-tab"},[_c('ly-tabbar',_vm._b({model:{value:(_vm.selectedId),callback:function ($$v) {_vm.selectedId=$$v},expression:"selectedId"}},'ly-tabbar',_vm.options,false),_vm._l((_vm.items),function(item,index){return _c('ly-tab-item',{key:index},[(_vm.options.fixBottom && item.icon)?_c('span',{attrs:{"slot":"icon"},slot:"icon"},[_c('i',{class:item.icon})]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(item[_vm.labelKey]))])])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3UMI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"ly-tab-item",style:(_vm.$parent.value === _vm.id ? _vm.activeStyle : {}),on:{"click":_vm.onItemClicked}},[(_vm.$parent.fixBottom)?_c('div',{staticClass:"ly-tab-item-icon"},[_vm._t("icon")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ly-tab-item-label"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Xnp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__teacher_index__ = __webpack_require__("b4GZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__u_gear_index__ = __webpack_require__("vISM");




/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/learning-center',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Gk10")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: '',
    redirect: 'index'
  }, {
    path: 'index',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("FNUm")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'card-records',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("U2CN")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'sign-up-code',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("pLFD")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'learning-center-detail',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9Ipi")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'set-admissions-wechat',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("PIkC")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'set-address/:schoolId',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wo53")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'learn-cards',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QQiE")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_1__teacher_index__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2__u_gear_index__["a" /* default */]))
});

/***/ }),

/***/ "4F/8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("y07C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f34a6a74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("3JXj");
function injectStyle (ssrContext) {
  __webpack_require__("kUQD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f34a6a74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "777y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__2020_index__ = __webpack_require__("QBLD");


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/activities',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Gk10")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [__WEBPACK_IMPORTED_MODULE_0__2020_index__["a" /* default */]]
});

/***/ }),

/***/ "8ATz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STUDENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TEXTAREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STUDENT_PHONE; });
var STUDENTS = 'school/school-detail/instead/STUDENTS';
var TEXTAREA = 'school/school-detail/instead/TEXTAREA';
var STUDENT_PHONE = 'school/school-detail/instead/STUDENT_PHONE';

/***/ }),

/***/ "8vfi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_modules_school_school_detail_manager__ = __webpack_require__("jyGv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__("+yHj");



var _getters, _mutations, _actions;




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    managerList: [],
    newManagerList: [],
    manager: null,
    schoolName: ''
  },
  getters: (_getters = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, __WEBPACK_IMPORTED_MODULE_3__types__["d" /* MANAGER_LIST */], function (state) {
    return state.managerList;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, __WEBPACK_IMPORTED_MODULE_3__types__["e" /* NEW_MANAGER_LIST */], function (state) {
    return state.newManagerList;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, __WEBPACK_IMPORTED_MODULE_3__types__["c" /* MANAGER */], function (state) {
    return state.manager;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_getters, __WEBPACK_IMPORTED_MODULE_3__types__["f" /* SCHOOL_NAME */], function (state) {
    return state.schoolName;
  }), _getters),
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["d" /* MANAGER_LIST */], function (state, payload) {
    state.managerList = payload.managerList;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["e" /* NEW_MANAGER_LIST */], function (state, payload) {
    state.newManagerList = payload.managerList;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["c" /* MANAGER */], function (state, payload) {
    state.manager = payload.manager;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["g" /* TOGGLE_FREEZE_MANAGER */], function (state) {
    state.manager.is_freeze = state.manager.is_freeze ? 0 : 1;
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["b" /* DELETE_MANAGER */], function (state) {
    var index = state.managerList.findIndex(function (manager) {
      return manager.id === state.manager.id;
    });
    if (index !== -1) {
      state.managerList.splice(index, 1);
    }
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["f" /* SCHOOL_NAME */], function (state, payload) {
    state.schoolName = payload.schoolName;
  }), _mutations),
  actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__types__["d" /* MANAGER_LIST */], function (_ref, payload) {
    var commit = _ref.commit;

    __WEBPACK_IMPORTED_MODULE_2__services_modules_school_school_detail_manager__["a" /* default */].fetchManagerList(payload.schoolId).then(function (data) {
      commit(__WEBPACK_IMPORTED_MODULE_3__types__["d" /* MANAGER_LIST */], {
        managerList: data
      });
    }, function () {});
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__types__["a" /* BATCH_CREATE_MANAGER */], function (_ref2, payload) {
    var state = _ref2.state,
        commit = _ref2.commit;

    __WEBPACK_IMPORTED_MODULE_2__services_modules_school_school_detail_manager__["a" /* default */].batchCreateManager(payload.managerList).then(function (data) {
      commit(__WEBPACK_IMPORTED_MODULE_3__types__["e" /* NEW_MANAGER_LIST */], {
        managerList: data.manager_list
      });
      commit(__WEBPACK_IMPORTED_MODULE_3__types__["d" /* MANAGER_LIST */], {
        managerList: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.manager_list), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(state.managerList))
      });
    }, function () {});
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__types__["g" /* TOGGLE_FREEZE_MANAGER */], function (_ref3, payload) {
    var state = _ref3.state,
        commit = _ref3.commit;

    __WEBPACK_IMPORTED_MODULE_2__services_modules_school_school_detail_manager__["a" /* default */].toggleFreezeManager(state.manager, payload.schoolId, payload.password).then(function () {
      commit(__WEBPACK_IMPORTED_MODULE_3__types__["g" /* TOGGLE_FREEZE_MANAGER */]);
    }, function () {});
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__types__["b" /* DELETE_MANAGER */], function (_ref4, payload) {
    var state = _ref4.state,
        commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_2__services_modules_school_school_detail_manager__["a" /* default */].deleteManager(state.manager, payload.schoolId, payload.password);
  }), _actions)
});

/***/ }),

/***/ "9RTs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationFrame__ = __webpack_require__("D7+0");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LyTabbar',

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: {
      type: String,
      default: 'red'
    },
    fixBottom: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: 0
    },

    // 近似等于超出边界时最大可拖动距离(px);
    additionalX: {
      type: Number,
      default: 50
    },
    // 惯性回弹指数(值越大，幅度越大，惯性回弹距离越长);
    reBoundExponent: {
      type: Number,
      default: 10,
      validator: function validator(value) {
        return value > 0;
      }
    },
    // 灵敏度(惯性滑动时的灵敏度,值越小，阻力越大),可近似认为速度减为零所需的时间(ms);
    sensitivity: {
      type: Number,
      default: 1000,
      validator: function validator(value) {
        return value > 0;
      }
    },
    // 回弹过程duration;
    reBoundingDuration: {
      type: Number,
      default: 360
    }
  },

  data: function data() {
    return {
      activeBarX: 0,
      activeBarWidth: 0,
      speed: 0, // 滑动速度(正常滑动时一般不会超过10);
      touching: false, // 是否处于touch状态;
      reBounding: false, // 是否处于回弹过程;
      translateX: 0,
      startX: 0,
      lastX: 0,
      currentX: 0,
      startMoveTime: 0,
      endMoveTime: 0,
      frameTime: 16.7, // 每个动画帧的ms数
      frameStartTime: 0,
      frameEndTime: 0,
      inertiaFrame: 0,
      zeroSpeed: 0.001, // 当speed绝对值小于该值时认为速度为0 (可用于控制惯性滚动结束期的顺滑度)
      acceleration: 0 // 惯性滑动加速度;
    };
  },


  computed: {
    style: function style() {
      if (this.fixBottom) return {};
      return {
        transitionTimingFunction: this.transitionTimingFunction,
        transitionDuration: this.transitionDuration + 'ms',
        transform: 'translate3d(' + this.translateX + 'px, 0px, 0px)'
      };
    },
    activeBarStyle: function activeBarStyle() {
      return {
        transition: 'all 300ms',
        width: this.activeBarWidth + 'px',
        height: this.lineWidth + 'px',
        transform: 'translate3d(' + this.activeBarX + 'px, 0, 0)',
        backgroundColor: this.activeColor
      };
    },
    transitionDuration: function transitionDuration() {
      if (this.touching || !this.reBounding && !this.touching) {
        return 0;
      }
      if (this.reBounding && !this.touching) {
        return this.reBoundingDuration;
      }
    },
    transitionTimingFunction: function transitionTimingFunction() {
      return this.reBounding ? 'cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'cubic-bezier(0.1, 0.57, 0.1, 1)';
    },

    // 可视区宽度;
    viewAreaWidth: function viewAreaWidth() {
      return this.$refs.viewArea.offsetWidth;
    },

    // 可视区与可滑动元素宽度差值;
    listWidth: function listWidth() {
      return this.$refs.list.offsetWidth - this.viewAreaWidth;
    },

    // 是否向左惯性滚动;
    isMoveLeft: function isMoveLeft() {
      return this.currentX <= this.startX;
    },
    isMoveRight: function isMoveRight() {
      return this.currentX >= this.startX;
    }
  },

  watch: {
    value: function value() {
      this.checkPosition();
      this.calcBarPosX();
    }
  },

  mounted: function mounted() {
    this.bindEvent();
    this.checkPosition();
    this.calcBarPosX();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationFrame__["a" /* windowInit */])();
  },
  destroyed: function destroyed() {
    this.removeEvent();
  },


  methods: {
    // start
    handleTouchStart: function handleTouchStart(event) {
      event.stopPropagation();
      cancelAnimationFrame(this.inertiaFrame);
      this.lastX = event.touches[0].clientX;
    },


    // move
    handleTouchMove: function handleTouchMove(event) {
      if (this.listWidth <= 0) return;
      event.preventDefault();
      event.stopPropagation();
      this.touching = true;
      this.startMoveTime = this.endMoveTime;
      this.startX = this.lastX;
      this.currentX = event.touches[0].clientX;
      this.moveFollowTouch();
      this.endMoveTime = event.timeStamp; // 每次触发touchmove事件的时间戳;
    },


    // end
    handleTouchEnd: function handleTouchEnd(event) {
      this.touching = false;
      if (this.checkReboundX()) {
        cancelAnimationFrame(this.inertiaFrame);
      } else {
        var silenceTime = event.timeStamp - this.endMoveTime;
        var timeStamp = this.endMoveTime - this.startMoveTime;
        timeStamp = timeStamp > 0 ? timeStamp : 8;
        if (silenceTime > 100) return; // 停顿时间超过100ms不产生惯性滑动;
        this.speed = (this.lastX - this.startX) / timeStamp;
        this.acceleration = this.speed / this.sensitivity;
        this.frameStartTime = new Date().getTime();
        this.inertiaFrame = requestAnimationFrame(this.moveByInertia);
      }
    },


    // 如果需要回弹则进行回弹操作并返回true;
    checkReboundX: function checkReboundX() {
      this.reBounding = false;
      if (this.translateX > 0) {
        this.reBounding = true;
        this.translateX = 0;
      } else if (this.translateX < -this.listWidth) {
        this.reBounding = true;
        this.translateX = -this.listWidth;
      }
      return this.translateX === 0 || this.translateX === -this.listWidth;
    },
    bindEvent: function bindEvent() {
      this.$el.addEventListener('touchstart', this.handleTouchStart, false);
      this.$el.addEventListener('touchmove', this.handleTouchMove, false);
      this.$el.addEventListener('touchend', this.handleTouchEnd, false);
    },
    removeEvent: function removeEvent() {
      this.$el.removeEventListener('touchstart', this.handleTouchStart);
      this.$el.removeEventListener('touchmove', this.handleTouchMove);
      this.$el.removeEventListener('touchend', this.handleTouchEnd);
    },


    // touch拖动
    moveFollowTouch: function moveFollowTouch() {
      if (this.isMoveLeft) {
        // 向左拖动
        if (this.translateX <= 0 && this.translateX + this.listWidth > 0 || this.translateX > 0) {
          this.translateX += this.currentX - this.lastX;
        } else if (this.translateX + this.listWidth <= 0) {
          this.translateX += this.additionalX * (this.currentX - this.lastX) / (this.viewAreaWidth + Math.abs(this.translateX + this.listWidth));
        }
      } else {
        // 向右拖动
        if (this.translateX >= 0) {
          this.translateX += this.additionalX * (this.currentX - this.lastX) / (this.viewAreaWidth + this.translateX);
        } else if (this.translateX <= 0 && this.translateX + this.listWidth >= 0 || this.translateX + this.listWidth <= 0) {
          this.translateX += this.currentX - this.lastX;
        }
      }
      this.lastX = this.currentX;
    },


    // 惯性滑动
    moveByInertia: function moveByInertia() {
      this.frameEndTime = new Date().getTime();
      this.frameTime = this.frameEndTime - this.frameStartTime;
      if (this.isMoveLeft) {
        // 向左惯性滑动;
        if (this.translateX <= -this.listWidth) {
          // 超出边界的过程;
          // 加速度指数变化;
          this.acceleration *= (this.reBoundExponent + Math.abs(this.translateX + this.listWidth)) / this.reBoundExponent;
          this.speed = Math.min(this.speed - this.acceleration, 0); // 为避免减速过程过短，此处加速度没有乘上frameTime;
        } else {
          this.speed = Math.min(this.speed - this.acceleration * this.frameTime, 0);
        }
      } else if (this.isMoveRight) {
        // 向右惯性滑动;
        if (this.translateX >= 0) {
          this.acceleration *= (this.reBoundExponent + this.translateX) / this.reBoundExponent;
          this.speed = Math.max(this.speed - this.acceleration, 0);
        } else {
          this.speed = Math.max(this.speed - this.acceleration * this.frameTime, 0);
        }
      }
      this.translateX += this.speed * this.frameTime / 2;
      if (Math.abs(this.speed) <= this.zeroSpeed) {
        this.checkReboundX();
        return;
      }
      this.frameStartTime = this.frameEndTime;
      this.inertiaFrame = requestAnimationFrame(this.moveByInertia);
    },


    // 计算activeBar的translateX
    calcBarPosX: function calcBarPosX() {
      if (this.fixBottom || !this.$children.length) return;
      if (this.$children.length <= this.value) return;
      var item = this.$children[this.value].$el;
      var itemWidth = item.offsetWidth;
      var itemLeft = item.offsetLeft;
      this.activeBarWidth = Math.max(itemWidth * 0.6, 14);
      this.activeBarX = itemLeft + (itemWidth - this.activeBarWidth) / 2;
    },


    // 点击切换item时，调整位置使当前item尽可能往中间显示
    checkPosition: function checkPosition() {
      if (this.fixBottom || !this.$children.length) return;
      if (this.$children.length <= this.value) return;
      var activeItem = this.$children[this.value].$el;
      var offsetLeft = activeItem.offsetLeft;
      var half = (this.viewAreaWidth - activeItem.offsetWidth) / 2;
      var changeX = 0;
      var absTransX = Math.abs(this.translateX);
      if (offsetLeft <= absTransX + half) {
        // item偏左，需要往右移
        var pageX = offsetLeft + this.translateX;
        changeX = half - pageX;
      } else {
        // item偏右，需要往左移
        changeX = -(offsetLeft - absTransX - half);
      }
      var lastX = changeX + this.translateX;
      // 两种边界情况
      lastX > 0 && (lastX = 0);
      lastX < -this.listWidth && (lastX = -this.listWidth);
      this.reBounding = true;
      this.translateX = lastX;
    }
  }
});

/***/ }),

/***/ "CnMB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/account',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Gk10")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: '',
    redirect: 'account-detail'
  }, {
    path: 'account-detail',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("tt5y")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'change-phone',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jxu9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'change-password',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XTss")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
});

/***/ }),

/***/ "CpHc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERR_LOG; });
/* unused harmony export ERR_LOG_BAK */
var ERR_LOG = 'school/school-detail/manager/ERR_LOG';
var ERR_LOG_BAK = 'school/school-detail/manager/ERR_LOG_BAK';

/***/ }),

/***/ "ETiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__("CpHc");



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    errLog: []
  },
  getters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* ERR_LOG */], function (state) {
    return state.errLog;
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* ERR_LOG */], function (state, payload) {
    state.errLog = payload.errLog;
  })
});

/***/ }),

/***/ "FsNw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/dual-meet',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Gk10")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: '',
    redirect: 'schedule'
  }, {
    path: 'schedule',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("VXGJ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'recruit',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NLy5")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'preview-game',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("eSL7")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'game',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("7Gz0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'game-image-list',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2NN5")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'share',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("7Fyq")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
});

/***/ }),

/***/ "FzZB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G0ld":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__manager_index__ = __webpack_require__("8vfi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__activity_index__ = __webpack_require__("ETiU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instead_index__ = __webpack_require__("vcTM");




/* harmony default export */ __webpack_exports__["a"] = ({
  modules: {
    manager: __WEBPACK_IMPORTED_MODULE_0__manager_index__["a" /* default */],
    activity: __WEBPACK_IMPORTED_MODULE_1__activity_index__["a" /* default */],
    instead: __WEBPACK_IMPORTED_MODULE_2__instead_index__["a" /* default */]
  }
});

/***/ }),

/***/ "GKcl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utils__ = __webpack_require__("hLWQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_school__ = __webpack_require__("lSvZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_learning_center_index__ = __webpack_require__("PWYP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_student_index__ = __webpack_require__("Mn2F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_dual_meet_index__ = __webpack_require__("sX7b");








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  strict: true,
  state: {
    openId: __WEBPACK_IMPORTED_MODULE_2__services_utils__["a" /* default */].Cookie.get('openid'),
    account: null
  },
  getters: {
    openId: function openId(state) {
      return state.openId;
    },
    isHeadMaster: function isHeadMaster(state) {
      return state.account && state.account.user_type_id === '6';
    },
    isManager: function isManager(state) {
      return state.account && state.account.user_type !== '6';
    }
  },
  modules: {
    school: __WEBPACK_IMPORTED_MODULE_3__modules_school__["a" /* default */],
    learningCenter: __WEBPACK_IMPORTED_MODULE_4__modules_learning_center_index__["a" /* default */],
    student: __WEBPACK_IMPORTED_MODULE_5__modules_student_index__["a" /* default */],
    dualMeet: __WEBPACK_IMPORTED_MODULE_6__modules_dual_meet_index__["a" /* default */]
  }
}));

/***/ }),

/***/ "JycB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd26cd6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("iaho");
function injectStyle (ssrContext) {
  __webpack_require__("2wlW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd26cd6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mn2F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_index__ = __webpack_require__("sRLk");


/* harmony default export */ __webpack_exports__["a"] = ({
  modules: {
    'create-student': __WEBPACK_IMPORTED_MODULE_0__create_index__["a" /* default */]
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fastclick__ = __webpack_require__("v5o6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_utils__ = __webpack_require__("hLWQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ly_tab__ = __webpack_require__("7HVg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts__ = __webpack_require__("XLwt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_weui_js__ = __webpack_require__("fO40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_weui_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_weui_js__);


// import wx from 'weixin-js-sdk';







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_ly_tab__["a" /* default */]);

__webpack_require__("TNmv");

var useragent = navigator.userAgent;
// 获取ios设备版本
var version = useragent.match(/cpu iphone os (.*?) like mac os/i);

if (!version) {
  __WEBPACK_IMPORTED_MODULE_2_fastclick___default.a.attach(document.body);
} else {
  /* eslint-disable */
  // ios 11 以上解决了 300ms 延迟
  if (parseInt(version[1]) < 11) {
    __WEBPACK_IMPORTED_MODULE_2_fastclick___default.a.attach(document.body);
  }
}

// document.oncontextmenu = ((e) => {
//   e.preventDefault();
// });

//软键盘关闭事件
document.body.addEventListener('focusout', __WEBPACK_IMPORTED_MODULE_3__services_utils__["a" /* default */].backToTop);

__WEBPACK_IMPORTED_MODULE_3__services_utils__["a" /* default */].Cookie.set('openid', __WEBPACK_IMPORTED_MODULE_3__services_utils__["a" /* default */].params('openid'));


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$weui = __WEBPACK_IMPORTED_MODULE_9_weui_js___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$echarts = __WEBPACK_IMPORTED_MODULE_8_echarts___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  timeout: 10 * 1000
});
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.common.Authorization = __WEBPACK_IMPORTED_MODULE_3__services_utils__["a" /* default */].storage('token') || '';

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('debounce', {
  bind: function bind(el, binding) {
    var eventName = 'touchend' in document ? 'touchend' : 'click';
    el.addEventListener(eventName, function (e) {
      // setTimeout 0 fix to IE 11
      setTimeout(function () {
        if (el.hasAttribute('disabled')) {
          e.preventDefault();
          return;
        }
        el.setAttribute('disabled', 'disabled');
        var fn = binding.value;
        var delay = 1000;
        if (fn) {
          fn();
        }
        setTimeout(function () {
          el.removeAttribute('disabled');
        }, delay);
      }, 0);
    });
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */]);
  }
});

/***/ }),

/***/ "OxTX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/students',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Gk10")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: '',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("IY+i")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: ':student_id/student-detail',
    name: 'studentDetail',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("WoA5")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: ':student_id/u-student-detail',
    name: 'uStudentDetail',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("GzPs")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: ':student_id/change-student-password',
    name: 'ChangeStudentPassword',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("d59l")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: ':student_id/card-list',
    name: 'CardList',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2kSB")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: ':student_id/course-detail',
    name: 'CourseDetail',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("echl")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: ':student_id/confirm-card',
    name: 'ConfirmCard',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("BEBr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: ':student_id/open-card-success',
    name: 'OpenCardSuccess',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Lpet")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: ':student_id/student-report',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("GHzh")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'duty-report',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Q6bU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: ':student_id/book-version',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jApV")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'recruit-student-list',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("tuzr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
});

/***/ }),

/***/ "PWYP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_teacher_index__ = __webpack_require__("ud2b");


/* harmony default export */ __webpack_exports__["a"] = ({
  modules: {
    'create-teacher': __WEBPACK_IMPORTED_MODULE_0__create_teacher_index__["a" /* default */]
  }
});

/***/ }),

/***/ "Py4K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_tabbar_vue__ = __webpack_require__("9RTs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_aad461cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_tabbar_vue__ = __webpack_require__("zOcG");
function injectStyle (ssrContext) {
  __webpack_require__("JycB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_tabbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_aad461cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_tabbar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QBLD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  path: '2020',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Gk10")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: 'annals',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("UkqU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
});

/***/ }),

/***/ "TNmv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tk/V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(key) {
    if (!key) return null;

    var rCookie = new RegExp('(^| )' + key + '=([^;]*)(;|$)');
    var matchs = document.cookie.match(rCookie);
    if (matchs && matchs.length > 2) {
      return decodeURIComponent(matchs[2]);
    }
    return null;
  },

  /*
   * @params {String} key
   * @params {Any} value
   * @params {Object} options { domain, path, expires(days) }
   */
  set: function set(key, value, options) {
    if (typeof value === 'undefined') return;

    var days = options && options.expires || 30;
    var expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    var cookie = key + '=' + encodeURIComponent(value) + ';expires=' + expires.toGMTString();
    if (options) {
      if (options.domain) {
        cookie = cookie + ';domain=' + options.domain;
      }
      if (options.path) {
        cookie = cookie + ';path=' + options.path;
      }
    }
    document.cookie = cookie;
  },
  del: function del(key, options) {
    if (typeof key === 'undefined') return;

    var expires = new Date();
    expires.setTime(expires.getTime() - 1);
    var value = this.get(key);
    var cookie = key + '=' + value + ';expires=' + expires.toGMTString();
    if (value != null) {
      cookie = key + '=' + value + ';expires=' + expires.toGMTString();
      if (options) {
        if (options.domain) {
          cookie = cookie + ';domain=' + options.domain;
        }
        if (options.path) {
          cookie = cookie + ';path=' + options.path;
        }
      }
      document.cookie = cookie;
    }
  }
});

/***/ }),

/***/ "Xvu3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/create-student',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Gk10")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: '',
    redirect: 'index'
  }, {
    path: 'index',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1Gt2")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'preview',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("eQXI")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: 'success',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("oTS/")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_account_index__ = __webpack_require__("CnMB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_learning_center_index__ = __webpack_require__("3Xnp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_student_index__ = __webpack_require__("OxTX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_student_create__ = __webpack_require__("Xvu3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_activities_index__ = __webpack_require__("777y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_share_index__ = __webpack_require__("qBzf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_dual_meet_index__ = __webpack_require__("FsNw");










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/login',
    name: 'Login',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xJsL")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QLKv")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, __WEBPACK_IMPORTED_MODULE_2__modules_account_index__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__modules_student_index__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__modules_student_create__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__modules_learning_center_index__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__modules_activities_index__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__modules_share_index__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__modules_dual_meet_index__["a" /* default */]]
}));

/***/ }),

/***/ "b4GZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: 'teacher-list',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("LxCS")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: 'create-teacher',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("P83b")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: 'preview',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("JQxY")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: 'successful',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ETey")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: 'teacher-detail/:teacher_id',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QK3D")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}]);

/***/ }),

/***/ "hLWQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_weui_js__ = __webpack_require__("fO40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_weui_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_weui_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_weixin_js_sdk__ = __webpack_require__("fxnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_weixin_js_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__core_cookie__ = __webpack_require__("Tk/V");







/* eslint-disable */






var utils = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8_weui_js___default.a, {
  Cookie: __WEBPACK_IMPORTED_MODULE_11__core_cookie__["a" /* default */],
  Array: {
    findIndex: function findIndex(array, value, key, startIndex) {
      var index = -1;

      for (var i = startIndex || 0; i < array.length; i += 1) {
        var item = array[i];
        if (key && item[key] === value[key]) {
          index = i;
          break;
        } else if (item === value) {
          index = i;
          break;
        }
      }

      return index;
    },
    exist: function exist(array, value, key) {
      var index = this.findIndex(array, value, key);

      return index !== -1;
    },
    existArray: function existArray(array, part, key) {
      var isAll = true;
      if (part) {
        for (var i = 0; i < part.length; i += 1) {
          var value = part[i];
          if (!this.exist(array, value, key)) {
            isAll = false;
            break;
          }
        }
      }
      return part && part.length && isAll;
    },
    find: function find(array, value, key) {
      var index = this.findIndex(array, value, key);

      if (index !== -1) {
        return array[index];
      } else {
        return undefined;
      }
    },
    unipush: function unipush(array, value, key) {
      if (!this.exist(array, value, key)) {
        array.push(value);
      }
    },
    pushReplace: function pushReplace(array, value, key) {
      if (this.exist(array, value, key)) {
        this.remove(array, value, key);
      }
      array.push(value);
    },
    remove: function remove(array, value, key) {
      var index = this.findIndex(array, value, key);

      if (index !== -1) {
        array.splice(index, 1);
      }
    },
    removeAll: function removeAll(array, value, key, startIndex) {
      var index = void 0;
      while (index !== -1) {
        index = this.findIndex(array, value, key, startIndex);
        if (index !== -1) {
          array.splice(index, 1);
        }
      }
    },
    toggle: function toggle(array, value, key) {
      if (this.exist(array, value, key)) {
        this.remove(array, value, key);
      } else {
        array.push(value);
      }
    },
    toggleArray: function toggleArray(array, part, key) {
      var _this = this;

      if (this.existArray(array, part, key)) {
        part.forEach(function (value) {
          return _this.remove(array, value, key);
        });
      } else {
        part.forEach(function (value) {
          return _this.unipush(array, value, key);
        });
      }
    },
    concat: function concat(array, part, index) {
      if (utils.isUndefined(index)) {
        index = array.length;
      }
      array.splice.apply(array, [index, 0].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(utils.isArray(part) ? part : [part])));
    },
    toMatrix: function toMatrix(array, rows, cols) {
      var matrix = [];
      for (var i = 0; i < rows; i += 1) {
        matrix[i] = [];
        for (var j = 0; j < cols; j += 1) {
          matrix[i][j] = array[i * cols + j];
        }
      }
      return matrix;
    },
    getArrEqual: function getArrEqual(arr1, arr2) {
      var newArr = [];
      for (var i = 0; i < arr2.length; i++) {
        for (var j = 0; j < arr1.length; j++) {
          if (arr1[j] === arr2[i]) {
            newArr.push(arr1[j]);
          }
        }
      }
      return newArr;
    },
    getArrRepeatNumber: function getArrRepeatNumber(array, value, key) {
      var number = 0;
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][key] === value[key]) {
          number += 1;
        }
      }
      return number;
    },
    sum: function sum(numbers) {
      return numbers.reduce(function (total, num) {
        return total + num;
      });
    }
  },
  Date: {
    format: function format(date, formatExp) {
      var result = formatExp;
      if (utils.isDate(date)) {
        var years = String(date.getFullYear());
        var months = date.getMonth() + 1;
        var days = date.getDate();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        var milliseconds = date.getMilliseconds();
        var spans = [{
          key: 'yyyy',
          value: years
        }, {
          key: 'yy',
          value: years.substr(-2)
        }, {
          key: 'MM',
          value: utils.leftPad(months, '0', 2)
        }, {
          key: 'M',
          value: months
        }, {
          key: 'dd',
          value: utils.leftPad(days, '0', 2)
        }, {
          key: 'd',
          value: days
        }, {
          key: 'HH',
          value: utils.leftPad(hours, '0', 2)
        }, {
          key: 'H',
          value: hours
        }, {
          key: 'mm',
          value: utils.leftPad(minutes, '0', 2)
        }, {
          key: 'm',
          value: minutes
        }, {
          key: 'ss',
          value: utils.leftPad(seconds, '0', 2)
        }, {
          key: 's',
          value: seconds
        }, {
          key: 'S',
          value: utils.leftPad(milliseconds, '0', 3)
        }];
        for (var i = 0; i < spans.length; i += 1) {
          var span = spans[i];
          result = result.replace(new RegExp(span.key, 'g'), span.value);
        }
      }
      return result;
    }
  },
  closeWindow: function closeWindow() {
    /* eslint-disable */
    if (WeixinJSBridge && WeixinJSBridge.invoke) {
      WeixinJSBridge.invoke('closeWindow', {}, window);
    }
  },
  pay: function pay(_ref) {
    var appId = _ref.appId,
        timestamp = _ref.timestamp,
        nonceStr = _ref.nonceStr,
        pkg = _ref.pkg,
        paySign = _ref.paySign,
        signType = _ref.signType;

    var _wx = __WEBPACK_IMPORTED_MODULE_9_weixin_js_sdk___default.a;
    return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      _wx.chooseWXPay({
        appId: appId,
        timestamp: timestamp,
        nonceStr: nonceStr,
        package: pkg,
        paySign: paySign,
        signType: signType,
        success: function success(res) {
          resolve(res);
        },
        cancel: function cancel(res) {
          resolve(res);
        },
        fail: function fail(err) {
          reject(err);
        }
      });
    });
  },
  noop: function noop() {},
  storage: function storage(key, data) {
    /* eslint-disable */
    var localStorage = window.localStorage;
    if (typeof data === 'undefined') {
      var value = localStorage.getItem(key);
      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    } else {
      if (data !== null) {
        localStorage.setItem(key, this.isString(data) ? data : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(data));
      } else {
        localStorage.removeItem(key);
      }
    }
    return null;
  },

  log: window.console.log.bind(window),
  redirect: function redirect(url) {
    window.location.href = url;
    // window.history.back(window.location.href = url);
  },
  title: function title(_title) {
    document.title = _title;
  },
  login: function login(token) {
    utils.storage('token', token);
    __WEBPACK_IMPORTED_MODULE_10_axios___default.a.defaults.headers.common['Authorization'] = token;
  },
  params: function params(key) {
    var params = {};

    var query = window.location.href;
    var rParam = /[?&]([^=&]+)(?:=([^&]*))?/g;
    var hits = void 0;
    var k = void 0;
    var v = void 0;
    /* eslint-disable */
    while (hits = rParam.exec(query)) {
      var _hits = hits;

      var _hits2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_hits, 3);

      k = _hits2[1];
      v = _hits2[2];

      params[k] = v ? decodeURIComponent(v) : null;
    }

    if (key) {
      if (key in params) {
        return params[key];
      }
      return undefined;
    }
    return params;
  },
  clone: function clone(data) {
    if (this.isObject(data)) {
      return JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(data));
    } else {
      return data;
    }
  },
  jsonify: function jsonify(obj) {
    var clone = {};
    if (obj) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
        if (utils.isObject(obj[key]) || utils.isArray(obj[key])) {
          clone[key] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(obj[key]);
        } else {
          clone[key] = obj[key];
        }
      });
    }
    return clone;
  },
  leftPad: function leftPad(value, pad, length) {
    value = String(value);
    while (value.length < length) {
      value = pad + value;
    }
    return value;
  },
  querystring: function querystring(json) {
    if (!json) return '';
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(json).map(function (key) {
      if (json[key] === undefined) return '';
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
    }).join('&');
  },
  secondsToTime: function secondsToTime(totalSeconds) {
    var time = '';
    var hours = 0;
    var minutes = 0;
    var seconds = 0;

    seconds = totalSeconds;

    hours = Math.floor(seconds / (60 * 60));
    if (hours) {
      seconds = seconds % (60 * 60);
    }
    minutes = Math.floor(seconds / 60);
    if (minutes) {
      seconds = seconds % 60;
    }

    if (hours) {
      if (hours < 10) {
        time = '0';
      }
      time += hours;
      time += ':';
    }
    if (minutes < 10) {
      time += '0';
    }
    time += minutes;
    time += ':';
    if (seconds < 10) {
      time += '0';
    }
    time += seconds;

    return time;
  },
  getApiPath: function getApiPath(url) {
    // 运维调整了跨域策略，统一改为同域调用接口（2020.4.3）
    // if (/^\/api\//i.test(url)) {
    //   /* eslint-disable */
    //   const host = window.location.host;
    //   if (/^teacher\.wx\.xxzx\.vip$/i.test(host)) {
    //     return `https://www.xxzx.vip${url}`;
    //   } else if (/^test\.passion\.vanthink\.cn$/i.test(host)) {
    //     return `https://test.xuexi.vanthink.cn${url}`;
    //   } else if (/^dev\.passionteacher\.wx\.vanthink\.cn$/i.test(host)) {
    //     return `https://dev.passion.vanthink.cn${url}`;
    //   }
    // }
    return url;
  },
  get: function get(url, params, loading, disableTopTip) {
    var options = {};
    var loadingInstance = void 0;

    if (utils.isObject(params)) {
      if ('params' in params) {
        options = params;
        params = options.params;
      } else {
        options.params = params;
      }
      options.params = utils.jsonify(options.params);
    } else if (params) {
      loading = params;
    } else {
      loading = false;
    }
    if (loading) {
      loadingInstance = utils.loading(loading);
    }

    if (!options.params) {
      options.params = {};
    }
    // if (!options.params.openid) {
    //   options.params.openid = utils.Cookie.get('openid');
    // }
    return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.get(utils.getApiPath(url), options).then(function (res) {
        if (loadingInstance) {
          loadingInstance.hide();
        }
        if (res.headers['x-redirect-to']) {
          utils.redirect(res.headers['x-redirect-to']);
        }
        if (res.data.code) {
          if (res.data.code === 44) {
            utils.storage('token', null);
            utils.redirect(location.origin + '/#/login?back=1');
          }
          if (!disableTopTip) {
            utils.topTips(res.data.message);
          }
          reject(res.data);
        } else if (utils.isUndefined(res.data.code)) {
          utils.topTips('系统繁忙，请稍后重试');

          reject(res.data);
        } else {
          resolve(res.data.data);
        }
      }).catch(function () {
        if (loadingInstance) {
          loadingInstance.hide();
        }
        utils.topTips('系统繁忙，请稍后重试');

        reject();
      });
    });
  },
  post: function post(url, data, loading) {
    var disableTopTip = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    var options = {};
    var loadingInstance = void 0;

    if (utils.isObject(data)) {
      if ('data' in data) {
        options = data;
        data = options.data;
      }
      data = utils.jsonify(data);
    } else if (data) {
      loading = data;
      data = null;
    } else {
      loading = false;
      data = null;
    }
    if (loading) {
      loadingInstance = utils.loading(loading);
    }

    if (!data) {
      data = {};
    }
    // if (!data.openid) {
    //   data.openid = utils.Cookie.get('openid');
    // }

    return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.post(utils.getApiPath(url), data, options).then(function (res) {
        if (loadingInstance) {
          loadingInstance.hide();
        }
        if (res.headers['x-redirect-to']) {
          utils.redirect(res.headers['x-redirect-to']);
        }
        if (res.data.code) {
          if (res.data.code === 44) {
            utils.storage('token', null);
            utils.redirect(location.origin + '/#/login?back=1');
          }
          if (disableTopTip) {
            utils.topTips(res.data.message);
          }
          reject(res.data);
        } else if (utils.isUndefined(res.data.code)) {
          utils.topTips('系统繁忙，请稍后重试');

          reject(res.data);
        } else {
          resolve(res.data.data);
        }
      }).catch(function () {
        if (loadingInstance) {
          loadingInstance.hide();
        }
        utils.topTips('系统繁忙，请稍后重试');

        reject();
      });
    });
  },
  error: function error(msg, stack) {
    __WEBPACK_IMPORTED_MODULE_7_vue__["a" /* default */].http.get('/front-error-log', {
      params: {
        message: msg,
        stack: stack
      }
    });
  },
  debounce: function debounce(fn, delay) {
    // 维护一个 timer
    var timer = null;

    return function () {
      // 通过 ‘this’ 和 ‘arguments’ 获取函数的作用域和变量
      var context = this;
      var args = arguments;

      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    };
  },
  backToTop: function backToTop() {
    window.scrollTo(0, 0);
  },
  isUndefined: function isUndefined(value) {
    return typeof value === 'undefined';
  },
  isBoolean: function isBoolean(value) {
    return typeof value === 'boolean';
  },
  isObject: function isObject(value) {
    return value !== null && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object';
  },
  isFunction: function isFunction(value) {
    return typeof value === 'function';
  },
  isString: function isString(value) {
    return typeof value === 'string';
  },
  isArray: function isArray(value) {
    return Array.isArray(value);
  },
  isDate: function isDate(value) {
    return Object.prototype.toString.call(value) === '[object Date]';
  }
});

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),

/***/ "iaho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"slide-left"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jyGv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__("hLWQ");


/* harmony default export */ __webpack_exports__["a"] = ({
  fetchManagerList: function fetchManagerList(schoolId) {
    return __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].get('/api/school/account/getManagerList', {
      school_id: schoolId
    }, '加载中···');
  },
  batchCreateManager: function batchCreateManager(managerList) {
    return __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].post('/api/school/account/createManagers', {
      manager_list: managerList
    }, '创建中···');
  },
  toggleFreezeManager: function toggleFreezeManager(manager, schoolId, password) {
    return __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].post('/api/school/account/freezeManager', {
      manager_id: manager.id,
      school_id: schoolId,
      is_freeze: manager.is_freeze ? 0 : 1,
      password: password
    }, '修改中···');
  },
  deleteManager: function deleteManager(manager, schoolId, password) {
    return __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].post('/api/school/account/deleteManager', {
      manager_id: manager.id,
      school_id: schoolId,
      password: password
    }, '删除中···');
  }
});

/***/ }),

/***/ "kUQD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lSvZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__school_detail_index__ = __webpack_require__("G0ld");


/* harmony default export */ __webpack_exports__["a"] = ({
  modules: {
    'school-detail': __WEBPACK_IMPORTED_MODULE_0__school_detail_index__["a" /* default */]
  }
});

/***/ }),

/***/ "muQq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qBzf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/share',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Gk10")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  children: [{
    path: 'certificate',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Cbe0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
});

/***/ }),

/***/ "sRLk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__("wHZ/");


var _getters, _mutations;



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    studentList: [],
    currentDate: null
  },
  getters: (_getters = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* STUDENT_LIST */], function (state) {
    return state.studentList;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* CURRENT_DATE */], function (state) {
    return state.currentDate;
  }), _getters),
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* STUDENT_LIST */], function (state, payload) {
    state.studentList = payload.studentList;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* CURRENT_DATE */], function (state, payload) {
    state.currentDate = payload.currentDate;
  }), _mutations)
});

/***/ }),

/***/ "sX7b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__("u3wh");



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    studentList: []
  },
  getters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* STUDENT_LIST */], function (state) {
    return state.studentList;
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* STUDENT_LIST */], function (state, payload) {
    state.studentList = payload.studentList;
  })
});

/***/ }),

/***/ "u3wh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STUDENT_LIST; });
/* eslint-disable */
var STUDENT_LIST = 'dual-meet/STUDENT_LIST';

/***/ }),

/***/ "uZYF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LyTabItem',
  computed: {
    activeStyle: function activeStyle() {
      return {
        color: this.$parent.activeColor
      };
    }
  },
  data: function data() {
    return {
      id: (this.$parent.$children.length || 1) - 1
    };
  },

  methods: {
    onItemClicked: function onItemClicked() {
      this.$parent.$emit('input', this.id);
    }
  }
});

/***/ }),

/***/ "ud2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__("2bfi");



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    teacherList: []
  },
  getters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* TEACHER_LIST */], function (state) {
    return state.teacherList;
  }),
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* TEACHER_LIST */], function (state, payload) {
    state.teacherList = payload.teacherList;
  })
});

/***/ }),

/***/ "vISM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  path: 'course-total',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/qDf")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: 'u-school-info',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("a8n+")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: 'contract-info',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("yPnQ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: 'choose-class',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XTHe")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}]);

/***/ }),

/***/ "vcTM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__("8ATz");


var _getters, _mutations;



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    students: [],
    textarea: '',
    studentPhone: []
  },
  getters: (_getters = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* STUDENTS */], function (state) {
    return state.students;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* TEXTAREA */], function (state) {
    return state.textarea;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* STUDENT_PHONE */], function (state) {
    return state.studentPhone;
  }), _getters),
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* STUDENTS */], function (state, payload) {
    state.students = payload.students;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* TEXTAREA */], function (state, payload) {
    state.textarea = payload.textarea;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* STUDENT_PHONE */], function (state, payload) {
    state.studentPhone = payload.studentPhone;
  }), _mutations)
});

/***/ }),

/***/ "wHZ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STUDENT_LIST; });
/* unused harmony export BATCH_CREATE_STUDENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CURRENT_DATE; });
var STUDENT_LIST = 'student/create/STUDENT_LIST';
var BATCH_CREATE_STUDENT = 'student/create/BATCH_CREATE_STUDENT';
var CURRENT_DATE = 'student/duty-report/CURRENT_DATE';

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_iconfont_iconfont_css__ = __webpack_require__("muQq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_iconfont_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_iconfont_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_global_scss__ = __webpack_require__("GKcl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_global_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_global_scss__);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App'
});

/***/ }),

/***/ "y07C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabbar__ = __webpack_require__("Py4K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tab_item__ = __webpack_require__("17Mt");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LyTab',
  components: {
    LyTabbar: __WEBPACK_IMPORTED_MODULE_0__tabbar__["a" /* default */],
    LyTabItem: __WEBPACK_IMPORTED_MODULE_1__tab_item__["a" /* default */]
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      selectedId: this.value
    };
  },

  computed: {
    labelKey: function labelKey() {
      return this.options.labelKey || 'label';
    }
  },
  watch: {
    value: function value(_value) {
      this.selectedId = _value;
    },
    selectedId: function selectedId(value) {
      this.$emit('input', value);
      this.$emit('change', this.items[value], value);
    }
  }
});

/***/ }),

/***/ "zOcG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"viewArea",staticClass:"ly-tabbar",class:{'ly-tabbar-fix-bottom': _vm.fixBottom}},[_c('div',{ref:"list",staticClass:"ly-tab-list",style:(_vm.style)},[_vm._t("default"),_vm._v(" "),(!_vm.fixBottom)?_c('div',{ref:"activeBar",staticClass:"ly-tab-active-bar",style:(_vm.activeBarStyle)}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.6de9b0d767b7018dea48.js